import { render, staticRenderFns } from "./order-pay-redirect.vue?vue&type=template&id=afe3eb94&"
import script from "./order-pay-redirect.vue?vue&type=script&lang=js&"
export * from "./order-pay-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports